module.exports = __webpack_public_path__ + "static/media/marker_selected.0c5f7fbe.svg";